import React, { useEffect, useState } from "react";
import { Form, Select, Button, Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import { PlusCircleOutlined } from "@ant-design/icons";
import styles from "./../../style.module.scss";
import { setDeviceId, setCenterPosition } from "../../goSlice";
import { useAppSelector, useAppDispatch } from "store/hook";

const { Option } = Select;

function Filter(props: any) {
  const [form] = Form.useForm();

  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { deviceId, record, ticketData } = useAppSelector((state) => state.goPage);
  const deviceIds = JSON.parse(
    JSON.stringify(
      ticketData?.ticket_inf?.new_id?.length > 0
        ? ticketData?.ticket_inf?.new_id
        : ticketData?.ticket_inf?.fix_id?.length > 0
        ? ticketData?.ticket_inf?.fix_id
        : []
    )
  ).sort();

  const onChange = (value: string) => {
    const id = value.split(" ")[0];
    const coordinate = ticketData?.node_inf?.[id]?.lat_long || [0, 0];
    dispatch(setDeviceId(id));
    dispatch(setCenterPosition(coordinate));
    form.setFieldValue("deviceIds", value);
  };

  // 選了不同 ticket filter 顯示該 ticket 的第一個 device id
  useEffect(() => {
    form.setFieldValue("selectedId", deviceId);
  }, [deviceId]);

  // FIXME: installation device id 排序
  // new_id_utc: {0533100000000004: {utc: 1684809921, date: '2023-05-23 10:45:21'}, {...}, {...}}
  // let new_id_utc: any[] = [];
  // let new_id_order: any[] = [];
  // Object.entries(ticketData?.ticket_inf?.new_id_utc).map((item: any) => {
  //   new_id_utc.push({
  //     id: item[0],
  //     utc: item[1]["utc"],
  //     date: item[1]["date"],
  //   });
  // });

  // new_id_utc.sort((a, b) => (a.utc < b.utc ? 1 : b.utc < a.utc ? -1 : 0));
  // new_id_utc.map((item: any) => {
  //   new_id_order.push(item["id"]);
  // });

  return (
    <>
      {deviceIds && (
        <div className={styles.Card}>
          <Form layout="vertical" form={form}>
            <div className="formwrap">
              <Row gutter={24} align="middle">
                <Col flex="1 1 100px">
                  <Form.Item name="selectedId" label={t("ISMS.DeviceId")} initialValue={""} className={styles.fill}>
                    <Select
                      placeholder={t("ISMS.SelectDevice")}
                      optionFilterProp="children"
                      className={styles.select}
                      onChange={onChange}
                    >
                      {deviceIds.map((item: string) => (
                        // <Option value={item} key={item} className={styles.F}>
                        <Option value={item} key={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {/* <Col flex="0 1 50px" style={{ padding: 0 }}>
                  <Form.Item>
                    <Button
                      type="text"
                      size={"large"}
                      // className={styles.goDeviceButton}
                      // key={index}
                      onClick={() => {
                        dispatch(setTicketVisible(true));
                        dispatch(setAddOrUpdate("add"));
                      }}
                    >
                      <PlusCircleOutlined />
                    </Button>
                  </Form.Item>
                </Col> */}
              </Row>
            </div>
          </Form>
        </div>
      )}
    </>
  );
}

export default Filter;
